export enum GridColumnAggregateEnum {
    None = 0,
    Sum = 1,
    Count = 2,
    Average = 3,
    Min = 4,
    Max = 5,
    LastKnownValue = 6,
    LastKnownHistoricalValue = 7
}
